/**
 * Préparation du payload PDF déposé dans AppWrite (lu par genpdf).
 *
 * Module pur : ni React, ni AppWrite. N'altère jamais `obj_data`.
 *
 * Contrat PWA → genpdf pour ECR/ECF (retail_interne / retail_externe) :
 *   - chaque ligne porte `discount` (valeur existante conservée, 0 si absente) ;
 *   - aucune clé `remise` n'est transmise (genpdf lit `discount`) ;
 *   - la clé `jewels` est retirée des adresses (n'existe pas en retail).
 * Les autres types de commande sont transmis inchangés.
 */

export type PdfOrderTypes = { retail_interne: unknown; retail_externe: unknown }

export function preparePdfData<T extends Record<string, any> | null | undefined>(
   type: unknown,
   obj_data: T,
   type_order: PdfOrderTypes,
): T {
   const isRetail = type === type_order.retail_interne || type === type_order.retail_externe
   if (!isRetail || !obj_data) return obj_data
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const { jewels, ...addresses_no_jewels } = obj_data.addresses ?? {}
   return {
      ...obj_data,
      lines: (obj_data.lines ?? []).map((l: Record<string, any>) => {
         // eslint-disable-next-line @typescript-eslint/no-unused-vars
         const { remise, ...rest } = l
         return { ...rest, discount: l.discount ?? 0 }
      }),
      addresses: addresses_no_jewels,
   } as T
}
